module.exports = __webpack_public_path__ + "img/go2yd.fcbb8817.jpg";